import './css/RolesSelector.css'
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import RolesCaja from './RolesCaja';
import CONFIG from '../config';

const URL = `${CONFIG.API_URL}/buscaRolesUsuario.php`;

function RolesSelector({acceder,rolSelect,configuracion, rol, rolesUsuario, setRolesUsuario}){
    const navigate = useNavigate();
    const [cargandoRol, setCargandoRol] = useState(true); // Estado para controlar la carga del rol
    const loggeduser =localStorage.getItem('loggeduser');
   
    const data= {
        'usuario' :  loggeduser,
        'modo'  :'buscarRolesUsuario'
    }
    
    useEffect( ()=>{
        LimpiarLocalStorage();
         if(acceder){
             axios.post(URL, data)
             .then(res =>{
                console.log('roles: ', res.data);
                 if(Array.isArray(res.data) && res.data.length > 0){ 
                     setRolesUsuario(res.data);
                     const savedRolId = localStorage.getItem('loggeduserRolId');
                     const savedNivelId = localStorage.getItem('loggeduserNivelId');
                     if (savedRolId && res.data.some(r => r.id == savedRolId && (savedNivelId ? r.id_nivel == savedNivelId : true))) {
                         const matchRol = res.data.find(r => r.id == savedRolId && (savedNivelId ? r.id_nivel == savedNivelId : true));
                         ingresar(matchRol);
                     } else if (res.data.length === 1) {
                         ingresar(res.data[0]);
                     } else {
                         setRolesUsuario(res.data);
                         setCargandoRol(false);
                     }
                 }else{
                     setRolesUsuario([]);
                     setCargandoRol(false);
                 }
             })
             .catch(err=>{
                 console.log(err);
                 setRolesUsuario([]);
                 setCargandoRol(false);
             })
     
        }else{
            localStorage.clear();
            rolSelect(null, null);
            navigate('/');
        }
    },[])

    const LimpiarLocalStorage = () => {
        localStorage.removeItem("loggeddatoscursos");
        localStorage.removeItem("loggeduserCurso");
        localStorage.removeItem("loggeduserCursoGrupo");
        localStorage.removeItem("loggeduserClasesCurso");
        localStorage.removeItem("loggeduserCursoGrupoO");
    }

    // Función para ingresar al rol seleccionado y cargar los localstorage correspondientes
    const ingresar = (rolObj) => {
        let id = typeof rolObj === 'object' ? rolObj.id : rolObj;
        let nivelId = (typeof rolObj === 'object' && rolObj.id_nivel) ? rolObj.id_nivel : null;
        localStorage.removeItem('loggeduserCurso');
        localStorage.removeItem('loggeduserCursoGrupoO');
        localStorage.setItem('loggeduserRolId', id);
        if (nivelId) {
            localStorage.setItem('loggeduserNivelId', nivelId);
        } else {
            localStorage.removeItem('loggeduserNivelId');
        }
        rolSelect(id, nivelId);
        navigate("/Principal");
    }


    return(
        <>
        {cargandoRol?
            <div className="container-principal">
                Cargando...
            </div>
        :
            <div className='container-principal mb-4 pb-4'>
                <h3 className='d-flex justify-content-center'>Seleccionar rol</h3>
                <div className='contenedor-roles'>
                    
                    { !!rolesUsuario && rolesUsuario.map((r, idx) =>(
                        <div key={r.id + '_' + (r.id_nivel || idx)}>
                            <RolesCaja ingresar={() => ingresar(r)} rol={r} rolSelect={rolSelect} configuracion={configuracion}/>
                        </div>
                    ))}
                </div>
            </div>
        }
        </>
    );
}

export default RolesSelector;